import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    imgUrls: [], // олон зураг хадгалах
    cdn: 'https://dmafilemanagement.s3.ap-southeast-1.amazonaws.com'
  },
  getters: {
    imgUrlsGetter: state => state.imgUrls,
    cdnGetter: state => state.cdn
  },
  mutations: {
    ADD_DYNAMIC_IMG_URL (state, url) {
      if (!state.imgUrls.includes(url)) state.imgUrls.push(url)
    },
    REMOVE_DYNAMIC_IMG_URL (state, url) {
      state.imgUrls = state.imgUrls.filter(u => u !== url)
    },
    CLEAR_DYNAMIC_IMG_URLS (state) {
      state.imgUrls = []
    },
    SET_CDN (state, cdn) {
      state.cdn = cdn
      localStorage.setItem('cdn', cdn)
    }
  },
  actions: {
    addDynamicImgUrl ({ commit }, url) {
      commit('ADD_DYNAMIC_IMG_URL', url)
    },
    removeDynamicImgUrl ({ commit }, url) {
      commit('REMOVE_DYNAMIC_IMG_URL', url)
    },
    clearDynamicImgUrls ({ commit }) {
      commit('CLEAR_DYNAMIC_IMG_URLS')
    }
  }
})
